import getConfig from '../config';

const LOGO_DEV_BASE_URL = 'https://img.logo.dev';
const { logoDevToken } = getConfig() as any;
const LOGO_DEV_TOKEN: string = logoDevToken || '';

const normalizeDomain = (domain?: string | null): string => {
    if (!domain) return '';
    // strip protocol and path, keep hostname only
    let clean = domain.trim();
    clean = clean.replace(/^https?:\/\//i, '');
    const slashIndex = clean.indexOf('/');
    if (slashIndex >= 0) {
        clean = clean.substring(0, slashIndex);
    }
    return clean;
};

const normalizeCompanyName = (name?: string | null): string => {
    if (!name) return '';
    return name.trim().toLowerCase().replace(/\s+/g, '');
};

const isDomainLike = (value: string): boolean => value.includes('.');

export const buildCompanyLogoUrl = (domainOrName?: string | null): string => {
    if (!domainOrName) return '';

    const trimmedValue = domainOrName.trim();
    if (!trimmedValue) return '';

    const useNamePath = !isDomainLike(trimmedValue);
    const cleanValue = useNamePath
        ? normalizeCompanyName(trimmedValue)
        : normalizeDomain(trimmedValue);

    if (!cleanValue) return '';

    const path = useNamePath ? `name/${encodeURIComponent(cleanValue)}` : cleanValue;

    if (LOGO_DEV_TOKEN) {
        return `${LOGO_DEV_BASE_URL}/${path}?token=${LOGO_DEV_TOKEN}`;
    }

    // Fallback without token if not configured
    return `${LOGO_DEV_BASE_URL}/${path}`;
};

